import { Storage } from '@intelipost-js/secure-providers';
import * as children from './pages/**/routes.js'; //eslint-disable-line

const PageBoxes = () => import('./PageBoxes');

const originMenu = Storage.get('originMenu', 'local') || 'oldmenu';
const pageTitle = originMenu === 'newmenu' ? 'Embalagens' : 'Gerenciar caixas';

export default {
  path: 'boxes',
  children: {
    boxesSettings: {
      name: 'boxes',
      path: '',
      component: PageBoxes,
      meta: {
        title: pageTitle,
      },
    },
    ...children,
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/boxes/routes.js